import React, { useState } from 'react';
import { Icon } from '@codex/icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import { priceMatchOpen, priceMatchClose, requestPriceMatch } from '../../../analytics';

const PriceMatchLabelContainer = styled.div`
  font-size: 13px;
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.primary.purple};
  p {
    margin: 0;
    font-weight: bold;
    padding: 5px;
    cursor: pointer;
  }
`;

const PoundSign = styled(Icon)`
  width: 13px;
  height: 18px;
  cursor: pointer;
`;

const Chevron = styled(Icon)`
  width: 9px;
  height: 21px;
  cursor: pointer;
`;

const PriceMatchContentContainer = styled.div`  
  font-size: 13px;
  text-align: left;
  position: relative;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0px 5px 5px #CCC;
  font-size: 13px;
  border-radius: 5px;

  &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #F5F5F5;
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
    clear: both;
  }
`;
const ContentTextContainer = styled.div`
  p {
    margin-bottom: 5px;
  }
`;

const PriceMatchLabel = styled.p`
  margin: 0 0 0 5px; 
  font-weight: bold;
`;

const StyledHr = styled.hr`
  border-top: 2px solid grey;
`;

const HeaderContainer = styled.div`
  height: 35px;
  display: flex;
  align-items: center;
  span {
    width: 35px;
    height: 35px;
  }
  svg {
    width: 35px;
  }
`;

export const PriceMatch = ({ translations, productId }) => {
  const {
    title, header, text, link
  } = translations;

  const StyledLinkContainer = styled.div`
    padding-top: 5px;
    color: ${({ theme }) => theme.colors.link.default};
  `;

  const [priceMatchActive, setPriceMatchActive] = useState(false);
  const rotate = priceMatchActive ? 180 : 0;

  const handlePriceMatch = () => {
    if (priceMatchActive) {
      priceMatchClose(productId);
    } else {
      priceMatchOpen(productId);
    }

    setPriceMatchActive(!priceMatchActive);
  };

  const handleRequestPriceMatch = () => {
    requestPriceMatch(productId);
  };

  return (
    <EnvironmentThemeProvider>
      <PriceMatchLabelContainer onClick={handlePriceMatch}>
        <PoundSign icon={'PricePromise'} />
        <p>{title}</p>
        <Chevron icon={'ArrowDown'} rotate={rotate} />
      </PriceMatchLabelContainer>
      {
        priceMatchActive && (
        <PriceMatchContentContainer>
          <HeaderContainer>
            <Icon icon={'PriceMatch'} />
            <PriceMatchLabel>{header}</PriceMatchLabel>
          </HeaderContainer>
          <StyledHr />
          <ContentTextContainer
            dangerouslySetInnerHTML={{ __html: text }}
            data-testid={'price-match-text'}
          />
          <StyledLinkContainer
            onClick={handleRequestPriceMatch}
            data-testid={'price-match-link'}
            dangerouslySetInnerHTML={{ __html: link }}
          />
        </PriceMatchContentContainer>
        )
}
    </EnvironmentThemeProvider>
  );
};

PriceMatch.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  productId: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
  productId: state.productInfo.productID
});

export default connect(mapStateToProps)(PriceMatch);
